import { BadgeCheck, Maximize2 } from "lucide-react";
import { CERTIFICATES } from "@/data/site";
import { SectionHeading } from "@/components/Shared";
import { useCertificate } from "@/components/CertificateProvider";

export const CertifiedTrusted = () => {
  const { open } = useCertificate();

  return (
    <section data-testid="certifications" className="section-py bg-brand-alt">
      <div className="container-px mx-auto max-w-[1400px]">
        <SectionHeading
          align="center"
          eyebrow="Certified & Trusted"
          title="Quality you can verify"
          intro="Faf's products and processes are certified by Ghana's leading regulatory bodies. Tap any certificate to view it in full."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CERTIFICATES.map((c, i) => (
            <button
              key={c.title}
              type="button"
              data-testid={`cert-card-${i}`}
              onClick={() => open(i)}
              className="group text-left rounded-3xl bg-white border border-black/5 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="img-zoom-wrap relative overflow-hidden aspect-[4/3] bg-brand-mist/30">
                <img src={c.image} alt={c.title} loading="lazy" className="img-zoom h-full w-full object-cover" />
                <div className="absolute inset-0 bg-brand-greenDark/0 transition-colors duration-300 group-hover:bg-brand-greenDark/30" />
                <span className="absolute top-3 right-3 grid h-9 w-9 place-items-center rounded-full bg-white/90 text-brand-greenDark opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Maximize2 size={16} />
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-brand-green">
                  <BadgeCheck size={18} />
                  <span className="text-xs font-medium tracking-wide uppercase">{c.issuer}</span>
                </div>
                <h3 className="mt-2 text-lg font-medium text-brand-ink leading-snug">{c.title}</h3>
                <p className="mt-2 text-sm text-brand-slate leading-relaxed">{c.text}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
